import * as React from 'react';
import Axios, { AxiosResponse } from 'axios';
import config from '../config';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Banner from '../components/parts/Banner';
import Helmet from 'react-helmet';
const ReactInputMask = require('react-input-mask');

const CancelToken = Axios.CancelToken;
let cancel: any;

interface IState {
    isLoading: boolean,
    inputs: {
        full_name: string,
        email: string,
        phone: string,
        subject: string,
        message: string,
        [key: string]: any

    },
    errors: {
        full_name: string,
        email: string,
        phone: string,
        subject: string,
        message: string,
        [key: string]: any
    },

}

class Feedback extends React.Component<any, IState>{
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        this.state = {
            isLoading: false,
            inputs: {
                full_name: "",
                email: "",
                phone: "",
                subject: "",
                message: ""
            },
            errors: {
                full_name: "",
                email: "",
                phone: "",
                subject: "",
                message: ""
            },
        };

    }

    validateInput(name: string, value: string) {

        return new Promise<any>((ok: any, error: any): any => {
            if (name == "phone") {
                this.setState({
                    errors: {
                        ...this.state.errors,
                        [name]: !value.match(/\+\9\9\8\([0-9]{2}\)[0-9]{3}\-[0-9]{2}\-[0-9]{2}/) ? (this.props.t("Необходимо заполнить") + " «" + this.props.t(name) + "»") : ""
                    }
                }, () => {
                    ok();
                });
            } else {
                this.setState({
                    errors: {
                        ...this.state.errors,
                        [name]: value == "" && name != "email" ? (this.props.t("Необходимо заполнить") + " «" + this.props.t(name) + "»") : ""
                    }
                }, () => {
                    ok();
                });
            }

        });
    }

    changeHandler(event: any) {
        let name = event.target.name;
        let value = event.target.value;

        this.setState({
            inputs: {
                ...this.state.inputs,
                [name]: value
            }
        });
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    blurHandler(event: any) {
        let name = event.target.name;
        let value = event.target.value;

        this.validateInput(name, value);
    }


    async submitHandler(event: any) {
        let hasError = false;

        for (let property in this.state.inputs) {
            await this.validateInput(property, this.state.inputs[property]);
        }

        for (let property in this.state.errors) {
            if (this.state.errors[property] != "") {
                hasError = true;
                break;
            }
        }

        if (!hasError && !this.state.isLoading) {
            this.setState({
                isLoading: true
            }, async () => {
                //axios
                let response: AxiosResponse = await Axios.post(`${config.host}/stat/feedback`, {
                    ...this.state.inputs
                });

                if (!this._isUnmounted) {
                    if (response.data.status == "error") {
                        let errors: any = {};

                        for (let prop in response.data.errors) {
                            errors[prop] = response.data.errors[prop].join(", ");
                        }
                        this.setState({
                            errors,
                            isLoading: false
                        });
                    } else {
                        this.setState({
                            isLoading: false,
                            inputs: {
                                full_name: "",
                                email: "",
                                phone: "",
                                subject: "",
                                message: ""
                            }
                        });
                        toast(this.props.t("Сообщение отправлено"));
                    }
                }
            });
        }
    }

    render() {
        const { t } = this.props;

        return (
            <div className="i-body">
                <Helmet>
                    <title>{t("Обратная связь") + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>
                </Helmet>
                <div className="container login-page v-index">
                    <div className="wrap games watch">
                        <div className="row">
                            <div className="col-md-9 col-xs-12">

                                <div className="info pb-20">
                                    <h3>{t("Обратная связь")}</h3>

                                    <form className=" form-horizontal" action=" " method="post" id="contact_form" onSubmit={async (e: any) => {
                                        e.preventDefault();

                                        await this.submitHandler(e);
                                    }}>

                                        <div className="form-group mt-20">
                                            <div className="col-md-6 inputGroupContainer">
                                                <div className="input-group">
                                                    <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                                                    <input name="full_name" onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.blurHandler(e)} value={this.state.inputs.full_name} placeholder={t("Ф.И.О.")} className="form-control" type="text" />
                                                </div>
                                                <p className="help-block help-block-error text-danger">{this.state.errors.full_name}</p>

                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div className="col-md-6 inputGroupContainer">
                                                <div className="input-group">
                                                    <span className="input-group-addon"><i className="glyphicon glyphicon-envelope"></i></span>
                                                    <input name="email" type="email" placeholder={t("Почта")} onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.blurHandler(e)} value={this.state.inputs.email} className="form-control" />
                                                </div>
                                                <p className="help-block help-block-error text-danger">{this.state.errors.email}</p>

                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div className="col-md-6 inputGroupContainer">
                                                <div className="input-group">
                                                    <span className="input-group-addon"><i className="glyphicon glyphicon-earphone"></i></span>
                                                    <ReactInputMask mask="\+\9\9\8(99)999-99-99" maskChar="_" name="phone" placeholder={t("Телефон")} onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.blurHandler(e)} value={this.state.inputs.phone} className="form-control" />
                                                </div>
                                                <p className="help-block help-block-error text-danger">{this.state.errors.phone}</p>

                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div className="col-md-6 inputGroupContainer">
                                                <div className="input-group">
                                                    <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                                                    <input name="subject" placeholder={t("Тема")} onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.blurHandler(e)} value={this.state.inputs.subject} className="form-control" type="text" />
                                                </div>
                                                <p className="help-block help-block-error text-danger">{this.state.errors.subject}</p>

                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div className="col-md-6 inputGroupContainer">
                                                <div className="input-group">
                                                    <span className="input-group-addon"><i className="glyphicon glyphicon-pencil"></i></span>
                                                    <textarea className="form-control" name="message" onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.blurHandler(e)} value={this.state.inputs.message} placeholder={t("Сообщение")}></textarea>
                                                </div>
                                                <p className="help-block help-block-error text-danger">{this.state.errors.message}</p>

                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div className="col-md-4">
                                                <button type="submit" className="btn btn-success">{this.state.isLoading ? (
                                                    <i className="fa fa-spinner fa-2x rotating "></i>
                                                ) : t("Отправить")} <span className="glyphicon glyphicon-send"></span></button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="col-md-3 col-xs-12">
                                <Banner className="banner300" place={39} />

                            </div>
                        </div>
                    </div>
                    <Banner className="banner235" place={40} />
                </div>
            </div>
        );
    }
}

export default withTranslation()(Feedback);